import React from "react";

const NoMatch = () => {
  return <div>No Match</div>;
};

export default NoMatch;
